export class RND {
    private _mz: number;
    private _mw: number;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor(seed?: number) {
        this._mz = 123456789;

        if (seed != undefined) {
            this.setSeed(seed);
        }
        else {
            this.randomize();
        }
    }

    //-------------------------------------------------------------------------
    /**
     * Sets and return random seed
     */
    //-------------------------------------------------------------------------
    randomize(): number {
        return (this._mw = this.randomIntIn(1, 0xffffffff, Math.random()));
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    setSeed(seed: number): void {
        if (seed == 0)
            seed += 1;

        this._mw = seed;
    }

    //-------------------------------------------------------------------------
    /**
     * Returns a pseudo-random number between 0 inclusive and 1 exclusive.
     * Algorithm used is MWC (multiply-with-carry) by George Marsaglia.
     * Implementation based on:
     * http://en.wikipedia.org/wiki/Random_number_generation#Computational_methods
     * http://stackoverflow.com/questions/521295/javascript-random-seeds#19301306
     */
    //-------------------------------------------------------------------------
    random(): number {
        let mz = this._mz;
        let mw = this._mw;

        // The 16 least significant bits are multiplied by a constant and then added to the 16 most significant bits. 32 bits result.
        mz = ((mz & 0xffff) * 36969 + (mz >> 16)) & 0xffffffff;
        mw = ((mw & 0xffff) * 18000 + (mw >> 16)) & 0xffffffff;

        this._mz = mz;
        this._mw = mw;

        let x = (((mz << 16) + mw) & 0xffffffff) / 0x100000000;

        return 0.5 + x;
    }

    //-------------------------------------------------------------------------
    /**
     * Returns a random float number between a (inclusive) and b (exclusive).
     * @param a 
     * @param b 
     * @param x If `x` is specified, it is used as the random number (between 0 inclusive and 1 exclusive, e.g., Math.random() could be passed as argument)
     */
    //-------------------------------------------------------------------------
    randomIn(a: number, b: number, x: number = this.random()): number {
        return a + x * (b - a);
    }

    //-------------------------------------------------------------------------
    /**
     * Returns a random integer between min and max inclusive.
     * @param a 
     * @param b 
     * @param x If `x` is specified, it is used as the random number (between 0 inclusive and 1 exclusive, e.g., Math.random() could be passed as argument)
     */
    //-------------------------------------------------------------------------
    randomIntIn(min: number, max: number, x: number = this.random()): number {
        return min + Math.floor(x * (max - min + 1));
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    randomBool(x: number = this.random()): boolean {
        return this.randomIn(0, 1) >= 0.5;
    }

    //-------------------------------------------------------------------------
    /**
     * Vyber prvku pole s pouzitim priority vyberu pro jednotlive prvky
     * @param priorities Pole s prioritami vyberu pro jednotlive prvky. Prvek musi mit prioritu > 0, aby byl zarazen do vyberu
     * @param resetSelTo Hodnota priority, na kterou ma byt resetovat vybrany prvek
     * @param incUnsel True, pokud ma byt navysena priorita nevybranych prvku
     * @returns Vraci index vybraneho prvku
     */
    //-------------------------------------------------------------------------
    choiceWithPriority(priorities: number[], resetSelTo: number = 0, incUnsel: boolean = true): number {
        // Soucet vsech priorit
        let sum = 0;
        let i = priorities.length;

        while (i-- != 0) {
            let p = priorities[i];

            if (p > 0)
                sum += p;
        }

        // Vybrat
        let res: number;

        if (sum != 0) {
            let sel = this.randomIntIn(0, sum - 1);

            i = priorities.length;

            while (i-- != 0) {
                let p = priorities[i];

                if (p > 0) {
                    if (p > sel) {
                        res = i;

                        // Resetovat prioritu vybrane polozky
                        priorities[i] = resetSelTo;
                        break;
                    }

                    sel -= p;
                }
            }
        }
        else {
            res = this.randomIntIn(0, priorities.length - 1);
        }

        // Navysit prioritu nevybranych polozek
        if (incUnsel) {
            i = priorities.length;

            while (i-- != 0)
                if (i != res)
                    priorities[i]++;
        }

        return res;
    }
}